import ajax from "../http.js";
import { EventEmitter } from "events";

class UserService extends EventEmitter {
  constructor() {
    super();
  }

  /**
   * Method to download report: GET
   */
  getAllUsers() {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Account/AllUsers`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  /**
   * Method to download report: GET
   */
  getUserById(id) {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Account/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  /**
   * Method to download report: GET
   */
  updateUser(user) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/${user.Id}`, user)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
        });
    });
  }

  getUser() {
    return new Promise((resolve, reject) => {
      ajax
        .get(`/Account/`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          resolve(error);
        });
    });
  }

  editUser(user) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/Edit`, user)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
        });
    });
  }

  createPaymentIntent(amount){
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/StripePaymentIntent`, amount)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
        });
    });
  }

  confirmPayment(data) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/ConfirmPaymentIntent`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
        });
    });
  }

  deleteUser(userId) {
    return new Promise((resolve, reject) => {
      ajax
        .post(`/Account/${userId}/Delete`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.ModelState) {
                let serverModelErrors = Object.values(error.response.data.ModelState).flat();
                resolve({ status: 400, errors: serverModelErrors });
              } else if (error.response.data.Message) {
                resolve({ status: 400, errors: [error.response.data.Message] });
              }
            }
          }
          resolve(error.response);
        });
    });
  }
}

const userService = new UserService();

userService.setMaxListeners(5);

export default userService;
